module.exports = __webpack_public_path__ + "static/img/1.f152c4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/1.jpg
// module id = 4pSx
// module chunks = 0